import { createAsyncThunk } from "@reduxjs/toolkit";
import { profileApi } from "@entities/profile";
import { getUUID, setAccessToken, setRefreshToken } from "@shared/lib/utils";
import { API } from "../authSlice";
import { LoginResponse } from "../types";

export const fastLogin = createAsyncThunk<LoginResponse, any, { rejectValue: { message: string } }>(
    "auth/fastLogin",
    async (payload: any, thunkAPI) => {
        try {
            const body = payload?.password
                ? {
                      phone: payload.phone,
                      password: payload.password
                  }
                : {
                      phone: payload.phone
                  };
            const response = await fetch(`${API}/v1/users/authentication/fast`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-DEVICE-UUID": getUUID()
                },
                body: JSON.stringify(body)
            });

            let data = await response.json();

            if (response.status === 200) {
                if (payload?.password) {
                    const token = data?.data?.accessToken;
                    const refreshToken = data?.data?.refreshToken;

                    if (!token) {
                        throw new Error("No token come from server");
                    }

                    setAccessToken(token);
                    setRefreshToken(refreshToken);

                    const profileQuery = profileApi.endpoints.getProfile.initiate({
                        accessToken: token
                    });

                    const res = await thunkAPI.dispatch(profileQuery);

                    localStorage.setItem("user", JSON.stringify(res.data));

                    return res.data;
                } else {
                    return {
                        data: data.data,
                        status: response.status
                    };
                }

                return data;
            } else {
                throw new Error(data.message);
            }
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ message: error.message });
        }
    }
);